import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { BranchMinimumCartSystemEntity } from '../../domain/entities/BranchMinimumCartSystemEntity'
import { BranchMinimumCartSystemValueType } from '../../domain/enums/BranchMinimumCartSystemValueType'

export class CreateUpdateBranchMinimumCartSystemModel extends BranchMinimumCartSystemEntity {
  constructor(dataDto: BranchMinimumCartSystemEntity) {
    super()
    mapEntityProperties<CreateUpdateBranchMinimumCartSystemModel>(this, dataDto, {
      exclude: ['id'],
      map: {
        perDirectDistance:
          dataDto.valueType === BranchMinimumCartSystemValueType.PER_DIRECT_DISTANCE
            ? dataDto.perDirectDistance
            : undefined,
        perDirectDistanceSegment:
          dataDto.valueType === BranchMinimumCartSystemValueType.PER_DIRECT_DISTANCE_SEGMENT
            ? dataDto.perDirectDistanceSegment
            : undefined
      }
    })
  }
}
